export * from './spotlight'



// WEBPACK FOOTER //
// ./src/app/shared/spotlight/index.ts